"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationInput = void 0;
const i18n_1 = require("../../i18n");
const mithril_1 = require("../../mithril");
const theme_1 = require("../theme");
const location_input_style_1 = require("./location.input.style");
const LocationField_input_1 = require("./LocationField.input");
(0, theme_1.addStyles)(location_input_style_1.Style);
exports.LocationInput = {
    view(state) {
        return (0, mithril_1.m)('div', { className: location_input_style_1.CSS.container }, [
            (0, mithril_1.m)('table', { className: location_input_style_1.CSS.tableInputs }, [
                LocationField_input_1.LocationFieldInput.view(state.latitude),
                LocationField_input_1.LocationFieldInput.view(state.longitude),
                LocationField_input_1.LocationFieldInput.view(state.altitude),
            ]),
            state.hasError() ? (0, mithril_1.m)('span', { className: location_input_style_1.CSS.MDL.error + ' ' + location_input_style_1.CSS.error }, (0, i18n_1.Translate)(state.error)) : null,
        ]);
    },
};
//# sourceMappingURL=location.input.js.map